import React from 'react';
import { JsonPropsType } from '../../../component-loader';
import { DocumentList, DocumentListProps } from './DocumentList';

export function DocumentListWrapper(props: JsonPropsType) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <DocumentList {...props as DocumentListProps} />;
}
